import React, { FC, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { giftCardMobx, memberMobx } from '@mobxStore'
import { useHistoryNew, toast } from '@utils'
import GiftCardProduct from '../../components/GiftCardProduct'
import mktController from 'controllers/mktController'
import { BackHeader } from 'pages/mkt/components'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const AllGiftCard: FC<IProps> = ({ location }) => {
  const history = useHistoryNew()
  const { eGiftCardList, getEGiftCardList } = giftCardMobx
  const { giftListForMy, getMemberGiftCards } = memberMobx
  const [isShow, setIsShow] = useState<boolean>(true)
  let giftCardIds: any[] = []
  if (location?.state) {
    const { giftCardIds: _giftCardIds } = location.state as any
    giftCardIds = _giftCardIds
  }
  const noHasGiftCards = useMemo(() => {
    return giftCardIds.length === 0 ? eGiftCardList : eGiftCardList.filter((item) => giftCardIds.includes(item.giftcardId))
  }, [eGiftCardList, giftCardIds])
  const handleGo = (path: string) => {
    history.push(path)
    // history.push(`/giftCard/buy/${cardId}`)
  }
  const goBack = () => {
    mktController.goBack(history)
  }
  const handleScroll = (e: any) => {
    setTimeout(() => {
      if (e.detail.scrollTop >= 50) {
        setIsShow(false)
      } else {
        setIsShow(true)
      }
    }, 10)
  }
  useIonViewWillEnter(() => {
    getEGiftCardList()
    getMemberGiftCards()
  }, [])

  return (
    <IonPage
      className='all-giftcard-page giftcard-page '
    >
      <BackHeader isShow={isShow} title={i18n.t('common.GiftCard')}></BackHeader>
      <IonContent className='page-content' scrollEvents onIonScroll={handleScroll}>
        <div className='card-list-container'>
          {
            giftListForMy && giftListForMy.length > 0 &&
              <div className='card-list'>
                {
                  giftListForMy.filter((item) => giftCardIds.length !== 0 ? giftCardIds.includes(item.giftcardId) : true).map((item: any) => {
                    return (
                      <div key={item.cardNo}>
                        <GiftCardProduct
                          type='small'
                          btnText={i18n.t('mkt.member.rechargeBalance')}
                          productInfo={{ ...item.giftcard, balance: item.balance, isRecharge: true, covers: [{ url: mktController.getGiftCardCover(item), shapes: [item?.extra?.shape || 'rectangle'] }] }}
                          clickEvent={(e: any) => {
                            if (item.status !== 'enable') {
                              return toast({ message: i18n.t('mkt.giftCard.cardIsFrozen') })
                            }
                            handleGo(`/iGc/recharge/${item.memberCardId}`)
                          }}
                        />
                      </div>
                    )
                  })
                }
              </div>
          }
          {
            noHasGiftCards.length > 0 &&
              <div className='card-list'>
                <div className='block-title'>{i18n.t('mkt.giftCard.buy')}</div>
                {
                  noHasGiftCards.map((item: IEGiftCardInfo, index: number) => (
                    <div key={item.giftcardId}>
                      <GiftCardProduct type='small' productInfo={item} clickEvent={(e: any) => handleGo(`/giftCard/buy/${item.giftcardId}`)} />
                    </div>
                  ))
                }
              </div>
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(AllGiftCard)
